/** Alert Type */
export enum ALERT_TYPE {
  DEMAND_OVERDUE = 'DEMAND_OVERDUE',
  PAYMENT_REMINDER = 'PAYMENT_REMINDER',
  MISSING_MAIL_ADDRESS = 'MISSING_MAIL_ADDRESS',
  MISSING_SEPA = 'MISSING_SEPA',
  TOS_CHANGED = 'TOS_CHANGED',
  CONFIRM_PERSONAL_DATA = 'CONFIRM_PERSONAL_DATA',
  NONE = ''
}
